import ProductsBreadcrumb from 'pages/UniversalProductsPage/ProductsBreadcrumb/ProductsBreadcrumb';

export default ProductsBreadcrumb;
